import { render } from "./ProjectForecast.vue?vue&type=template&id=55c78046&scoped=true"
import script from "./ProjectForecast.vue?vue&type=script&lang=js"
export * from "./ProjectForecast.vue?vue&type=script&lang=js"

import "./ProjectForecast.vue?vue&type=style&index=0&id=55c78046&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c78046"]])

export default __exports__